// pages/dataProcessing/DataProcessing.jsx
import React from 'react';
import LateralMenu from '../../components/LateralMenu/LateralMenu';
import DataProcessingComponent from '../../components/DataProcessing/DataProcessing';
import { Box } from '@mui/material';

const DataProcessing = () => {
  return (
    <>
      <LateralMenu />
      <main>
            <Box sx={{
                width: "100%",
                minHeight: "100vh",
                bgcolor: "#e7eaef",

            }}>
        <DataProcessingComponent />
        </Box>
      </main>
    </>
  );
};

export default DataProcessing;